import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { PageNavContext } from "../FunctionalPageLoginStart";
import "./RightElements.css";

const CerificateButton = () => {
	const onPageNav = useContext(PageNavContext);
	const navigate = useNavigate();

	const handleGoLearning = () => {
		if (onPageNav) {
			onPageNav("Invata");
			return;
		}
		navigate("/functionalpagelogin");
	};

	return (
		<div className="rightmenu-card certificate-button-card">
			<div className="section">
				<span className="get-pro-title">Certificate</span>
				<div className="section-desc" style={{ marginTop: 12 }}>
					Completeaza cursurile pentru a debloca certificatele tale oficiale.
				</div>
				<button type="button" className="go-learning" style={{ marginTop: 8 }} onClick={handleGoLearning}>
					Continua invatarea
				</button>
			</div>
		</div>
	);
};

export default CerificateButton;
